<script setup>
import {requestHttp} from "@/services/HttpRequest";
import {inject, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import Li from "@/components/ConfigMenu/Li.vue";

const rootScope = inject('rootScope');
const router = useRouter();

const menus = ref([]);
const openIndexes = ref(new Set()); // qué submenús están abiertos

const ontoggleMenu = () => {
  rootScope.toggleMenu = !rootScope.toggleMenu;
};

const toggleSubmenu = (index) => {
  if (openIndexes.value.has(index)) {
    openIndexes.value.delete(index);
  } else {
    openIndexes.value.add(index);
  }
  // forzar reactividad del Set
  openIndexes.value = new Set(openIndexes.value);
};

const getMenu = async () => {
  const response = await requestHttp({
    endpoint: 'auth/getMenu',
    method: 'GET'
  });
  return response.data;
};

const fetchMenu = async () => {
  const response = await getMenu();
  if (rootScope.estado === 502) {
    await router.push('/');
    return [];
  }
  const navMenu = response.data;

  const groups = new Set(navMenu.map(item => item.descripcion));
  return [...groups].map(g => ({
    name: g,
    values: navMenu.filter(i => i.descripcion === g)
  }));
};

const loadMenu = async () => {
  menus.value = await fetchMenu();
};

onMounted(() => {
  loadMenu();
});
</script>

<template>
  <nav class="md:block md:fixed md:top-0 md:bottom-0  md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative  md:overflow-y-auto z-20  py-4 border-right-1 border-gray-200" style="width: 330px; left: 0">
    <div class="mt-4">
      <button class="p-link layout-menu-button layout-topbar-button" @click="ontoggleMenu">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <hr class="my-4 md:min-w-full"/>

    <div v-for="(menu, index) in menus" :key="index">
      <button
          class="md:min-w-full text-info-500 hover:text-info-600 text-base uppercase font-bold block pt-1 pb-4 no-underline focus:outline-none text-left dropdown-btn-custom bg-white border-none"
          @click="toggleSubmenu(index)">
        <i class="pi pi-chevron-down mr-2" aria-hidden="true"></i>
        {{ menu.name }}
        <hr class="my-4 md:min-w-full"/>
      </button>

      <ul
          class="md:flex-column md:min-w-full flex-column align-items-start list-none dropdown-container"
          :style="{ display: openIndexes.has(index) ? 'flex' : 'none' }">
        <Li v-for="(value, i) in menu.values" :key="i" :pagina="value.pagina" :submenu="value.submenu" />
      </ul>
    </div>
  </nav>
</template>